import MatchTheSentence from './MatchTheSentence';

export default MatchTheSentence;
